module.exports = __webpack_public_path__ + "img/login-elrosario.a9ac4224.svg";